import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "dropdown"]

  show() {
    const dropdown = this.dropdownTarget
    dropdown.classList.remove("d-none")

    // If using fixed positioning (for providers hover), calculate position,
    // keeping the panel inside the viewport (phones open it near the right
    // edge; flip above the trigger when there's no room below).
    if (getComputedStyle(dropdown).position === 'fixed') {
      const margin = 8
      const triggerRect = this.triggerTarget.getBoundingClientRect()
      const width = dropdown.offsetWidth
      const height = dropdown.offsetHeight
      const maxLeft = window.innerWidth - width - margin
      const left = Math.max(margin, Math.min(triggerRect.left, maxLeft))
      let top = triggerRect.bottom + margin
      if (top + height > window.innerHeight - margin) {
        top = Math.max(margin, triggerRect.top - margin - height)
      }
      dropdown.style.top = `${top}px`
      dropdown.style.left = `${left}px`
    }
  }

  hide() {
    this.dropdownTarget.classList.add("d-none")
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("d-none")) {
      this.show()
    } else {
      this.hide()
    }
  }

  hideIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
